<template>
    <page title="eventRegistration">
        <template #pageContainer>
            <v-row>
                <v-col
                    cols="12"
                    md="12" class="py-1">
                    <v-card>
                        <v-data-table
                            v-if="filteredEventCompetitions !== null"
                            v-model="selected"
                            :headers="headers"
                            :items="filteredEventCompetitions"
                            class="elevation-1"
                            :page.sync="Pagination.currentPage"
                            :items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.userManagementLoading')"
                            :server-items-length="filteredEventCompetitions.length"
                            item-key="id"
                            hide-default-footer
							:height="WindowSize.y - 360"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="3" lg="3">
                                            <v-btn-toggle dense
                                                color="primary"
                                                active-class="action-active">
                                                <v-btn
                                                    color="primary"
                                                    @click="newCompetitionApproval">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newCompetition`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>

                                        <v-col cols="12" sm="7" lg="7">
                                            <v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="freetextSearch"
                                                :label="$t('text.search')">
                                            </v-text-field>
                                        </v-col>

                                        <!-- <v-col cols="12" sm="2" lg="2"
                                                align="right">
                                            <v-btn-toggle dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col> -->
                                    </v-row>
                                </v-container>
                            </template>
                            <template #item.maxPeople="{ item }">
                                <template v-if="item.maxPeople !== 0">({{ item.maxPeople }}/{{ item.currentPeople }})</template>
                                <template v-else>({{$t('text.unlimited')}} / {{ item.currentPeople }} )</template>
                            </template>
                            <template #item.eventDate="{ item }">
                                {{ item.eventDate | moment('DD.MM.YYYY') }}
                            </template>
                            <template #item.action="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="editEventRegistartion(item)">
                                            <v-icon>
                                                edit
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.edit`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="deleteEventRegistartion(item.id)">
                                            <v-icon>
                                                delete
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.delete`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="openDialog(item)">
                                            <v-icon>
                                                email
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.email`) }}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>


                        <!-- <pagination
                            :currentPage="Pagination.currentPage"
                            :totalPages="Pagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination> -->
                    </v-card>

                                <v-dialog
                                    v-model="emailDialog.show"
                                    width="60%">
                                    <v-card>
                                    <v-card-title v-if="emailDialog.event">
                                        {{ emailDialog.event.name }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-textarea
                                            v-if="!emailDialog.sent"
                                            outlined dense
                                            hide-details="auto"
                                            :label="$t('text.email')"
                                            :height="WindowSize.y * 0.3"
                                            v-model="emailDialog.emailText"
                                        ></v-textarea>
                                        <v-alert
                                            v-if="emailDialog.sent"
                                            type="success">
                                            {{$t('text.messageSent')}}
                                        </v-alert>
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-actions
                                            v-if="!emailDialog.sent">
                                        <v-spacer></v-spacer>
                                        <v-btn
                                        text
                                        :disabled="emailDialog.emailText.trim() === ''"
                                        @click="sendEmail"
                                        >
                                        {{$t('text.send')}}
                                        </v-btn>
                                        <v-btn
                                        text
                                        @click="emailDialog.show = false"
                                        >
                                        {{$t('text.abort')}}
                                        </v-btn>
                                    </v-card-actions>
                                    </v-card>
                                </v-dialog>
                </v-col>
            </v-row>
            <spinner :loading="loading"></spinner>
        </template>

    </page>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import Page from '../../general/Page.vue';
import Spinner from '../../general/Spinner.vue';
// import Pagination from '../../general/Pagination.vue';

import eventRegistrationActions from '../../store/actions/eventRegistration';
import namespace from '../../store/namespace';

import modelState from '../../mixins/modelState';

export default {
	name: 'EventRegistrationList',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
		// Pagination,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: '154px',
				},
				{
					text: this.$i18n.t('text.headerCompetitionName'), align: 'left', value: 'name', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerCompetitionDate'), align: 'left', value: 'eventDate', sortable: false, width: 50,
				},
				{
					text: this.$i18n.t('text.headerTown'), align: 'left', value: 'city', sortable: false,
				},
				{
					text: this.$i18n.t('text.country'), align: 'left', value: 'country', sortable: false,
				},
				{
					text: this.$i18n.t('text.eventMaxPeople'), align: 'left', value: 'maxPeople', sortable: false,
				},
			],
			loading: true,
			selected: [],
			freetextSearch: '',
			emailDialog: {
				show: false,
				sent: false,
				event: null,
				emailText: '',
			},
			// queryParameters: {
			// 	pageNumber: 1,
			// 	pageSize: 10,
			// 	freetextSearch: null,
			// },
		};
	},
	async mounted() {
		this.REMOVE_EVENT_COMPETITION();
		if (this.EventRegistrationLinks.length === undefined || this.EventRegistrationLinks.length === 0) {
			await this.GET_EVENT_REG_LINKS();
		}
		await this.loadData();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.EVENTREGISTRATION, ['EventRegistrationLinks', 'EventRegList', 'Pagination']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		filteredEventCompetitions() {
			if (this.search !== '') {
				return this.EventRegList.filter(x => x.name.includes(this.freetextSearch)
				|| x.city.includes(this.freetextSearch)
				|| x.country.includes(this.freetextSearch)
				|| this.$moment(x.eventDate).format('DD.MM.YYYY').includes(this.freetextSearch));
			}
			return this.EventRegList;
		},
	},
	methods: {
		...mapActions(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.GET_EVENT_REG_LINKS,
			eventRegistrationActions.GET_ORG_EVENT_COMPETITIONS,
			eventRegistrationActions.DELETE_EVENT_REGISTRATION,
			eventRegistrationActions.SEND_MAIL,
		]),
		...mapMutations(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.REMOVE_EVENT_COMPETITION,
			eventRegistrationActions.SET_EVENT,
		]),
		// async pageSizeChanged(newPageSize) {
		// 	this.queryParameters.pageSize = newPageSize;

		// 	await this.loadData(this.queryParameters);
		// },
		newCompetitionApproval() {
			this.$router.push({ name: 'neweventregistration' });
		},
		async loadData() {
			this.loading = true;
			try {
				await this.GET_ORG_EVENT_COMPETITIONS({ id: this.Organization }); // , queryParameters: this.queryParameters
			} finally {
				this.loading = false;
			}
		},
		// async search() {
		// 	localStorage.setItem('compApprQP', JSON.stringify(this.queryParameters));
		// 	this.queryParameters.pageNumber = 1;
		// 	await this.loadData(this.queryParameters);
		// },
		// async current(newPage) {
		// 	this.queryParameters.pageNumber = newPage;
		// 	await this.loadData(this.queryParameters);
		// },
		editEventRegistartion(event) {
			this.SET_EVENT(event);
			this.$router.push({
				name: 'updateeventregistration',
				params: { eGuid: event.id },
			});
		},
		async deleteEventRegistartion(id) {
			// eslint-disable-next-line no-restricted-globals, no-alert
			const r = confirm(this.$i18n.t('text.deleteRequest'));
			if (r === true) {
				try {
					const link = this.EventRegistrationLinks.find(x => x.rel === 'delete_event_reg');
					if (link) {
						const href = link.href
							.replace('{eventId}', id);
						await this.DELETE_EVENT_REGISTRATION(href);
						this.loadData(this.queryParameters);
					}
				} catch (ex) {
					console.log(ex);
				}
			}
		},
		openDialog(event) {
			this.emailDialog.show = true;
			this.emailDialog.event = event;
		},
		async sendEmail() {
			this.loading = true;
			const link = this.EventRegistrationLinks.find(x => x.rel === 'inform_attendees');
			if (link) {
				const href = link.href
					.replace('{eventId}', this.emailDialog.event.id);
				await this.SEND_MAIL({ href, data: { content: this.emailDialog.emailText } });
				this.emailDialog.sent = true;
				setTimeout(this.hideDialog, 5000);
			}
			this.loading = false;
		},
		hideDialog() {
			this.emailDialog = {
				show: false,
				emailText: '',
				event: null,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}

.header{
    font-weight: bold;
}

p {
    margin:0px!important;
}
</style>
